let wScroll = 0;

window.toggleScroll = function(action) {
  const body = document.querySelector('body');
  const siteWrapper = document.querySelector('#site-wrapper');
  const toggleAction = action;
  if (toggleAction === 'disable') {
    wScroll = window.scrollY;
    const cHeight = siteWrapper.offsetHeight;
    body.style.height = `${cHeight}px`;
    body.style.top = `-${wScroll}px`;
    body.classList.add('disable-scroll');
  } else {
    body.style.height = null;
    body.style.top = null;
    body.classList.remove('disable-scroll');
    window.scroll(0,wScroll);
  }
}



// WEBPACK FOOTER //
// ./scripts/util/toggleScroll.js